export const kardiaZaps = [
    {
      // Kaidex
      zapAddress: '0xF433FD81A580250ee3cfa79464d96D4D15482BE1',
      ammRouter: '0x66153fDc998252C0A98764933e2fC8D1B1009C2B',
      ammFactory: '0x64203f29f4d6a7e199b6f6aFbe65F1fa914c7C4e',
      ammPairInitHash: '0x4829a2cb5b5cd2280b139796d23e1bea43f7caddf4203454607c5a9f3d9f95b6',
    },
    {
      // BecoSwap
      zapAddress: '0xB0f6CF3335E3eeADCd20A8AAA87E7F6f429BFB2b',
      ammRouter: '0x20487A569D05bE994B5E0549dD276FB625401C67',
      ammFactory: '0x58b54BCDF2aF8a70dD6433EB39b308148261bB49',
      ammPairInitHash: '0xbc2e0e6843476e2b4125dd4831781e818561ebcdc908b21207ba2724a52d3af7',
    },
    {
      // Kaidex v3
      zapAddress: '0x7d3Bc15455e76203766D8c6a1F5849494F6644a4',
      ammRouter: '0xbAFcdabe65A03825a131298bE7670c0aEC77B37f',
      ammFactory: '0xC9567a8B6b622cdc8076C6b4432Ade0e11F50Da1',
      ammPairInitHash: '0xf264d894da1070a80bc479a9f9b59d7dba3d8977144aba4ba53652b31ab31da1',
    }
];
  